import { Link, NavLink } from "react-router-dom";
import "../../../App.css";
import headerLog from "../../../RichImages/nav-white-logo-main.png";

// ── Mini Footer ─────────────────────────────────────────
const MiniFooter = () => {
  return (
    <footer className="tw-bg-gray-900 tw-text-white ">
      <div className="tw-flex tw-items-center tw-justify-between tw-px-6 sm:tw-px-10 tw-py-5">
        {/* Left Logo */}
        <NavLink to="/" className="tw-flex-shrink-0 tw-no-underline">
          <img
            src={headerLog}
            alt="Geeta777"
            className="tw-h-10 md:tw-h-10 tw-w-auto tw-opacity-90 hover:tw-opacity-100 tw-transition tw-duration-300"
          />
        </NavLink>

        {/* Right Scroll To Top Button */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center
                     tw-rounded-xl tw-transition-all tw-duration-300
                     tw-border tw-border-white/20 tw-cursor-pointer
                     tw-bg-white/10 tw-text-[#1e6ebe]
                     hover:tw-bg-[#1e6ebe] hover:tw-text-white hover:tw-border-[#1e6ebe]"
        >
          ↑
        </button>
      </div>
    </footer>
  );
};

const FullFooter = ({ variant = "full" }) => {
  const handleClickUp = () => {
    const targetElement = document.getElementById("root");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* ================= MINI FOOTER — MOBILE ONLY ================= */}
      {variant === "mini" && (
        <footer className="tw-bg-gray-900 tw-text-white tw-py-6 tw-mt-3 tw-px-4 md:tw-hidden">
          <div className="tw-max-w-7xl tw-mx-auto">
            <div className="tw-flex tw-items-center tw-justify-between">
              {/* Logo */}
              <img
                src={headerLog}
                alt="Laksh365"
                className="tw-h-8 tw-w-auto"
              />

              {/* Scroll Button */}
              <button
                onClick={handleClickUp}
                aria-label="Scroll to top"
                className="footer-btn-scroll tw-flex tw-items-center tw-justify-center tw-shrink-0"
              >
                <svg viewBox="0 0 512 512" height={22} width={22}>
                  <path d="M348.3 216.4c-5 5.1-13.3 5.1-18.4.1L269 155.8v231.3c0 7.1-5.8 12.9-13 12.9s-13-5.8-13-12.9V155.8l-60.9 60.8c-5.1 5-13.3 4.9-18.4-.1-5-5.1-5-13.2.1-18.3l83-82.4z" />
                </svg>
              </button>
            </div>
          </div>
        </footer>
      )}

      {/* ================= FULL FOOTER — TABLET + DESKTOP ================= */}
      <footer
        className={`tw-bg-gray-900 tw-text-white tw-py-12 tw-mt-8 tw-px-4 md:tw-px-12
        ${variant === "mini" ? "tw-hidden md:tw-block" : ""}`}
      >
        {/* Floating Scroll Button */}
        <div className="footer-btn-scroll-main">
          <button
            className="footer-btn-scroll"
            onClick={handleClickUp}
            aria-label="Scroll to top"
          >
            <svg viewBox="0 0 512 512" height={25} width={25}>
              <path d="M348.3 216.4c-5 5.1-13.3 5.1-18.4.1L269 155.8v231.3c0 7.1-5.8 12.9-13 12.9s-13-5.8-13-12.9V155.8l-60.9 60.8c-5.1 5-13.3 4.9-18.4-.1-5-5.1-5-13.2.1-18.3l83-82.4z" />
            </svg>
          </button>
        </div>

        <div className="tw-max-w-7xl tw-mx-auto">
          {/* Grid */}
          <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-8 tw-mb-8">

            {/* Brand */}
            <div className="tw-space-y-4">
              <img
                src={headerLog}
                alt="Laksh365"
                className="tw-h-9 tw-w-auto"
              />
              <p className="tw-text-gray-400 tw-text-sm tw-leading-relaxed">
                India's Most Trusted Platform For Online Matka. Play
                Responsibly With Secure Transactions And 24/7 Support.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="tw-font-semibold tw-text-base tw-mb-4">
                Quick Links
              </h4>
              <ul className="tw-space-y-2">
                <li><Link to="/" className="footer-link">Home</Link></li>
                <li><Link to="/charts" className="footer-link">Charts</Link></li>
                <li><Link to="/rates" className="footer-link">Rates</Link></li>
                <li><Link to="/" className="footer-link"></Link></li>
                <a
                  href="/downloads/Laksh365-V1772539409887.apk"
                  target="_blank"
                  download
                  className="footer-link"
                >
                  Markets
                </a>
                <li><Link to="/about-us" className="footer-link">About Us</Link></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="tw-font-semibold tw-text-base tw-mb-4">
                Support
              </h4>
              <ul className="tw-space-y-2">
                <li><Link to="" className="footer-link">Help Center</Link></li>
                <li><Link to="" className="footer-link">Contact Us</Link></li>
                <li>
                  <a href="https://wa.me/91XXXXXXXXXX" className="footer-link">
                    WhatsApp Support
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="tw-font-semibold tw-text-base tw-mb-4">
                Legal
              </h4>
              <ul className="tw-space-y-2">
                <li><Link to="" className="footer-link">Terms & Conditions</Link></li>
                <li><Link to="" className="footer-link">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="tw-border-t tw-border-gray-800 tw-pt-6 tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-gap-4">
            <p className="tw-text-gray-500 tw-text-sm tw-text-center md:tw-text-left">
              © 2025 LAKSH365 | All Rights Reserved
            </p>

            <div className="tw-flex tw-gap-6">
              <Link to="" className="tw-text-yellow-400 hover:tw-text-yellow-300 tw-text-sm">
                Privacy Policy
              </Link>
              <Link to="" className="tw-text-yellow-400 hover:tw-text-yellow-300 tw-text-sm">
                Connect With Us
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Shared link style */}
      <style>{`
        .footer-link {
          color: #9ca3af;
          font-size: 14px;
          transition: color .2s ease;
        }
        .footer-link:hover {
          color: white;
        }
      `}</style>
    </>
  );
};

export default function Footer({ variant = "full" }) {
  if (variant === "mini") {
    return <MiniFooter />;
  }

  return <FullFooter />;
}
